import {_request, _requestForm} from "./api";


export const item = (entities_guide) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'entities/'+String(entities_guide), method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
